// MODIFIED: Uses getHistory prop (from Hook) instead of direct Axios
import { useState, useEffect, useCallback } from "react";
import CloseIcon from "@mui/icons-material/Close";
import HistoryIcon from "@mui/icons-material/History";
import loadingSpinner from "../../../../../assets/loading.gif";
import { Input, TextArea } from "../../../../../common/Input";

export function SalaryAdvanceHistoryModal({ isOpen, onClose, selectedSar, getHistory }) {
  const [loading, setLoading] = useState(false);
  const [schedule, setSchedule] = useState([]);
  const [loanHeader, setLoanHeader] = useState(null);

  const fetchData = useCallback(async () => {
    if (!selectedSar?.referenceNumber) return;
    setLoading(true);
    // REPLACED: Direct Axios call with Hook-based helper
    const { loan, schedule: historyData } = await getHistory(selectedSar.referenceNumber);
    setLoanHeader(loan);
    setSchedule(historyData);
    setLoading(false);
  }, [selectedSar, getHistory]);

  useEffect(() => { if (isOpen) fetchData(); }, [isOpen, fetchData]);

  const handleClose = () => { setSchedule([]); setLoanHeader(null); onClose(); };

  if (!isOpen) return null;

  const formatAmt = (n) => Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const formatDate = (dateStr) => (!dateStr || dateStr.startsWith("0001") ? "—" : new Date(dateStr).toLocaleDateString());

  return (
    <div role="dialog" aria-modal="true" className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 text-gray-700 overflow-auto">
      <div className="bg-gray-50 w-full md:w-[90%] lg:w-[70%] xl:w-[60%] rounded-lg shadow-xl h-auto max-h-[90vh] flex flex-col relative">
        <div className="flex justify-between items-center px-6 py-2 border-b border-gray-200 bg-white sticky top-0 z-10 rounded-t-lg">
          <div className="flex items-center gap-2">
            <HistoryIcon className="text-customMainColor" />
            <h2 className="text-xl font-semibold text-customMainColor">
              Loan Repayment History
            </h2>
          </div>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-700 bg-transparent border-none cursor-pointer"
          >
            <CloseIcon />
          </button>
        </div>

        <div className="p-6 overflow-y-auto flex-grow space-y-6">
          {loading ? (
            <div className="flex justify-center py-10"><img src={loadingSpinner} alt="loading" className="w-12 h-12" /></div>
          ) : !loanHeader ? (
            <div className="flex flex-col items-center py-16 text-gray-400"><p className="text-lg font-medium">No established loan record found</p></div>
          ) : (
            <>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4">
                <Input label="Employee" value={selectedSar.employeeFullName} isViewOnly={true} />
                <Input label="Prepared At" value={loanHeader?.createdAt ? formatDate(loanHeader.createdAt) : 'N/A'} isViewOnly={true} />
                <Input label="Reference" value={loanHeader.referenceNumber} isViewOnly={true} />
                <Input label="Approved" value={`₱${formatAmt(loanHeader.approvedAmount)}`} isViewOnly={true} className="font-bold text-green-700" />
                <Input label="Status" value={loanHeader.loanStatus?.toUpperCase()} isViewOnly={true} />
              </div>

              <div className="grid grid-cols-1">
                <TextArea
                  row={4}
                  label="Remarks"
                  value={loanHeader.loanStatus?.toUpperCase()}
                  isViewOnly={true}
                />
              </div>

              <div className="border border-gray-300 rounded-lg bg-white shadow-sm overflow-hidden">
                <table className="w-full text-sm text-left">
                  <thead className="bg-gray-50 border-b border-gray-200">
                    <tr>
                      <th className="px-4 py-3 font-semibold text-gray-600">Inst. #</th>
                      <th className="px-4 py-3 font-semibold text-gray-600">Expected Date</th>
                      <th className="px-4 py-3 font-semibold text-gray-600">Deducted At</th>
                      <th className="px-4 py-3 font-semibold text-gray-600 text-right">Amount Due</th>
                      <th className="px-4 py-3 font-semibold text-gray-600 text-center">Status</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {schedule.map((item) => (
                      <tr key={item.id} className="hover:bg-gray-50">
                        <td className="px-4 py-3 text-gray-500">{item.installmentNumber}</td>
                        <td className="px-4 py-3">{formatDate(item.scheduledDate)}</td>
                        <td className="px-4 py-3">{item.payrollPeriodName ? `(${item.payrollPeriodName}) - cutoff` : '--'}</td>
                        <td className="px-4 py-3 text-right font-medium text-blue-600">₱{formatAmt(item.amountToDeduct)}</td>
                        <td className="px-4 py-3 text-center">
                          <span className={`text-[10px] font-bold px-3 py-1 rounded-full border ${item.deductionStatus === "Completed" ? "bg-green-50 text-green-700 border-green-200" : "bg-gray-50 text-gray-500 border-gray-200"}`}>
                            {item.deductionStatus?.toUpperCase()}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
        <div className="flex justify-end p-5 border-t border-gray-200 bg-white rounded-b-lg">
          <button onClick={handleClose} className="bg-gray-400 text-white px-8 py-2 rounded">Close</button>
        </div>
      </div>
    </div>
  );
}